let googleMap;
let arrPinsOnMap = [];
const INITIAL_POSITION_BOUNDS = new google.maps.LatLngBounds(
        {lat: boundsFromShortcode.south, lng: boundsFromShortcode.west},
        {lat: boundsFromShortcode.north, lng: boundsFromShortcode.east}
    );

function closeRoomModal(itemMarker, infowindows){
    document.querySelectorAll(`.closeModal`).forEach( closeBtn => {
        closeBtn.addEventListener('click', event => {
            event.preventDefault();
            googleMap.fitBounds(INITIAL_POSITION_BOUNDS);
            // infowindows.close(googleMap, itemMarker);
            if(document.querySelector(`.eachModalRoom.modal_open`))
                document.querySelector(`.eachModalRoom.modal_open`).classList.remove('modal_open');
        })
    } );
}

function buildMarkerContent(itemMarker, infowindows){
    let contentMarker = `<div class="markerContent">${itemMarker.title}</div>`

    infowindows = new google.maps.InfoWindow({
        content: contentMarker,
    });

    infowindows.open(googleMap, itemMarker);

    return infowindows;
}

function openRoomModal( name ){
    if( document.querySelector(`.eachModalRoom.modal_open`) && document.querySelector(`.eachModalRoom.modal_open`).dataset.name != name ){
        document.querySelector(`.eachModalRoom.modal_open`).classList.remove('modal_open');
    }

    let modalToOpen = document.querySelector(`.eachModalRoom[data-name="${name}"]`);

    arrPinsOnMap.forEach(itemMarker => {
        let infowindows;

        if( itemMarker.title == name ){
            itemMarker.setIcon(iconHover);
            itemMarker.addListener('mouseout', function () {
                itemMarker.setIcon(iconHover);
            })
            var latLng = itemMarker.getPosition();
            googleMap.panTo(latLng);
            // infowindows = buildMarkerContent(itemMarker, infowindows);
            closeRoomModal( itemMarker, infowindows );
        }else{
            itemMarker.setIcon(iconDefault);
        }
    });

    modalToOpen.classList.add('modal_open');
}

function loadMarker(pin, mapInitialized, iconNormalState, iconHoverState) {
    let { id, name, lat, long } = pin;

    let marker = new google.maps.Marker({
        id: id,
        map: mapInitialized,
        title: name,
        icon: iconNormalState,
        zIndex: 1,
        position: new google.maps.LatLng(lat, long),
    });

    marker.addListener('click', () => openRoomModal(marker.title));
    marker.addListener('mouseover', () => {
        marker.setIcon(iconHoverState) 
    });
    marker.addListener('mouseout', () => {
        marker.setIcon(iconNormalState) 
    });

    return marker;
}

function buildGoogleMaps({ config, pins }){
    const   ZOOM = config.map_zoom,
            MAP_TYPE = config.map_type,
            STYLES_MAP = JSON.parse(config.snazzy),
            NORMAL_STATE_PIN = config.regular_pin.normal,
            HOVER_STATE_PIN = config.regular_pin.hover,
            CONTAINER_ON_BUILD_MAP = document.querySelector(`.interactiveMap_mapHolder`);

    const OPTIONS_GOOGLE_MAPS = {
        zoom: ZOOM,
        mapTypeId: MAP_TYPE,
        mapTypeControl: false,
        styles: STYLES_MAP,
        scrollwheel: false,
        disableDoubleClickZoom: false,
        backgroundColor: '#ffffff',
        panControl: false,
        zoomControl: true,
        streetViewControl: false,
        cameraControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER,
        },
    };

    (googleMap = new google.maps.Map(CONTAINER_ON_BUILD_MAP, OPTIONS_GOOGLE_MAPS));

    googleMap.fitBounds(INITIAL_POSITION_BOUNDS);

    pins.forEach((pin) => {
        let marker = loadMarker(pin, googleMap, NORMAL_STATE_PIN, HOVER_STATE_PIN);
        arrPinsOnMap.push(marker);
    });
}

let z_index_markers = 99;
function getAccommodatiosForIteractiveMap({ state = 'All', city = 'All', brand = 'All' }, mapAndListHolder){
	fetch(`${site_url}ajax/functions.php?operation=getAccommodatiosForIteractiveMap&state=${state}&city=${city}&brand=${brand}`)
	.then( data => data.json() )
	.then( response => {
        mapAndListHolder.innerHTML = response.html;
        buildGoogleMaps(response);
        document.querySelectorAll(`.eachRoomList`).forEach( room => {
            room.addEventListener('click', () => {
                openRoomModal( room.dataset.name );
            })
            room.addEventListener('mouseover', () => {
                arrPinsOnMap.forEach(itemMarker => {
                    let infowindows;
                    let name = room.dataset.name
            
                    if( itemMarker.title == name ){
                        itemMarker.setIcon(iconHover);
                        itemMarker.addListener('mouseout', function () {
                            itemMarker.setIcon(iconHover);
                        })
                        itemMarker.setZIndex(z_index_markers)
                        var latLng = itemMarker.getPosition();
                        googleMap.panTo(latLng);
                        // infowindows = buildMarkerContent(itemMarker, infowindows);
                        closeRoomModal( itemMarker, infowindows );
                    }else{
                        itemMarker.setIcon(iconDefault);
                    }
                    z_index_markers++;
                });
            })
        } )

        if(document.querySelector(`.interactiveMap_slider`)){
            const interactiveMap_slider = new Swiper('.interactiveMap_slider', {
                slidesPerView: 1,
                speed: 800,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                    el: ".interactiveMap_pagination",
                    dynamicBullets: true,
                },
            });
        }
	} )
}

function loadFilterInteractiveMap(){
	let interactive_map = document.querySelector(`.js-interactive_map`);
    let allContainerOfOptions = interactive_map.querySelectorAll('.js-interactiveMap_boxOption_filter'),
        resetButton = interactive_map.querySelector('.js-interactiveMap_reset'),
        mapAndListHolder = interactive_map.querySelector('.js-holder_map_list');
    let stateFilter = {
            state: 'All',
            city: 'All',
            brand: 'All'
        }

    allContainerOfOptions.forEach( holder => {
        let selector = holder.querySelector('button'),
            spanShowSelectedOption = holder.querySelector('.js-interactiveMap_activeOption'),
            listOfOptions = holder.querySelector('.js-interactiveMap_options');

        selector.addEventListener('click', event => {
            listOfOptions.classList.toggle('active')
            if( !listOfOptions.classList.contains('active') ){
                selector.classList.remove('open')
            }else{
                selector.classList.add('open')
            }
        })

        holder.addEventListener('mouseleave', () => {
            if(listOfOptions.classList.contains('active')){
                listOfOptions.classList.remove('active');
                selector.classList.remove('open');
            }
        });

        listOfOptions.addEventListener('click', e => {
            let elementClicked = e.target;

            if( elementClicked.nodeName == 'LI' ){
                listOfOptions.classList.remove('active')
                if( listOfOptions.querySelector('li.active') ){
                    listOfOptions.querySelector('li.active').classList.remove('active')
                }

                elementClicked.classList.add('active');
                spanShowSelectedOption.innerHTML = elementClicked.textContent;
                stateFilter[`${listOfOptions.dataset.filter}`] = elementClicked.dataset.value;
                getAccommodatiosForIteractiveMap( stateFilter, mapAndListHolder );
            }
        })
    } )
    
    resetButton.addEventListener('click', event => {
        event.preventDefault();
        allContainerOfOptions.forEach( holder => {
            holder.querySelector('.js-interactiveMap_options > li').click();
        } )
    })

    getAccommodatiosForIteractiveMap( stateFilter, mapAndListHolder );
}

document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector(`.js-interactive_map`)){
        loadFilterInteractiveMap();
    }
});